import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";
import { MEDIA_TYPES, MEDIA_CONFIGS, validateMediaFile } from "../../utils/constants/mediaConstants";

export const sendMediaMessageApi = async (params, authHeaders) => {
  try {
    const {
      conversationId,
      mediaType,
      mediaLink,
      caption,
      filename,
    } = params;

    if (!conversationId) {
      return {
        status: false,
        errMsg: "Conversation ID is required",
      };
    }

    if (!mediaType || !MEDIA_TYPES[mediaType]) {
      return {
        status: false,
        errMsg: `Invalid media type. Supported types: ${Object.keys(MEDIA_TYPES).join(", ")}`,
      };
    }

    if (!mediaLink) {
      return {
        status: false,
        errMsg: "Media link is required",
      };
    }

    const media = {
      link: mediaLink,
    };

    if (caption) {
      media.caption = caption;
    }

    if (mediaType === MEDIA_TYPES.DOCUMENT && filename) {
      media.filename = filename;
    }

    const payload = {
      operation: "SEND_MESSAGE",
      payload: {
        conversationId,
        content: {
          type: mediaType,
          media,
        },
      },
    };

    const res = await apiCallPost(
      apiPaths.getConversation,
      payload,
      authHeaders
    );

    if (res && res.messageId && res.status) {
      return {
        status: true,
        data: res,
      };
    }

    return {
      status: false,
      errMsg: res?.msg || res?.errMsg || `Failed to send ${mediaType} message`,
    };
  } catch (err) {
    console.error("Error sending media message:", err);
    return {
      status: false,
      errMsg: err?.message || "Error sending media message",
    };
  }
};

export const sendTextMessageApi = async (params, authHeaders) => {
  try {
    const { conversationId, text } = params;

    if (!conversationId) {
      return {
        status: false,
        errMsg: "Conversation ID is required",
      };
    }

    if (!text || !text.trim()) {
      return {
        status: false,
        errMsg: "Message text is required",
      };
    }

    const payload = {
      operation: "SEND_MESSAGE",
      payload: {
        conversationId,
        content: {
          type: "TEXT",
          body: text.trim(),
        },
      },
    };

    const res = await apiCallPost(
      apiPaths.getConversation,
      payload,
      authHeaders
    );

    if (res && res.messageId && res.status) {
      return {
        status: true,
        data: res,
        msg: "Message sent successfully",
      };
    }

    return {
      status: false,
      errMsg: res?.msg || res?.errMsg || "Failed to send message",
    };
  } catch (err) {
    console.error("Error sending text message:", err);
    return {
      status: false,
      errMsg: err?.message || "Error sending message",
    };
  }
};

// Re-export for backward compatibility
export { MEDIA_TYPES, MEDIA_CONFIGS, validateMediaFile };
